define('adminWebhookHistoryEditPopupView',[
  'app',
  'module',
  'underscore',
  'jquery',
  'marionette',
  'bootbox',
  'template!adminWebhookHistoryEditPopupView',
  'entities/webhook_history'
], function (
  App,
  Module,
  _,
  $,
  Marionette,
  Bootbox,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'admin-webhook-history-edit-popup-view',

    ui: {
      afterInput: '.after-input'
    },

    events: {
      'click .btn-cancel': 'onCancel',
      'click .btn-save': 'onSave',
      'click .btn-save-retry': 'onSaveRetry'
    },

    serializeData: function () {
      return {
        type: this.model.get('type') || '',
        status: this.model.get('status') || '',
        url: this.model.get('url') || '',
        afterObject: this.prettify(this.model.get('afterObject')),
        urlLabel: _.i18n('admin.webhookHistory.url', null, 'URL'),
        afterLabel: _.i18n('admin.webhookHistory.afterObject', null, 'Data'),
        cancelLabel: _.i18n('common.cancel', null, 'Cancel'),
        saveLabel: _.i18n('common.save', null, 'Save'),
        saveRetryLabel: _.i18n('admin.webhookHistory.saveAndRetry', null, 'Save & re-execute')
      };
    },

    prettify: function (str) {
      if (!str) { return ''; }
      try {
        return JSON.stringify(JSON.parse(str), null, 2);
      } catch (e) {
        return str;
      }
    },

    getData: function () {
      var data = {};
      var after = this.ui.afterInput.val();

      if (after !== '') {
        data.afterObject = this.minify(after,
          _.i18n('admin.webhookHistory.invalidAfter', null, 'The data is not valid JSON.'));
        if (data.afterObject === null) { return null; }
      }
      return data;
    },

    minify: function (str, errorMsg) {
      try {
        return JSON.stringify(JSON.parse(str));
      } catch (e) {
        Bootbox.alert(errorMsg);
        return null;
      }
    },

    onSave: function () {
      var self = this;
      var data = this.getData();
      if (!data) { return; }
      App.request('webhook-history:update', this.model.get('id'), data).done(function (resp) {
        self.model.set(resp);
        if (self.options.onConfirm) { self.options.onConfirm(); }
        self.windowView.close();
      }).fail(function () {
        Bootbox.alert(_.i18n('common.error', null, 'Something went wrong. Please try again.'));
      });
    },

    onSaveRetry: function () {
      var self = this;
      var data = this.getData();
      if (!data) { return; }
      App.request('webhook-history:update', this.model.get('id'), data).done(function () {
        App.request('webhook-history:retry', self.model.get('id')).done(function (resp) {
          self.model.set(resp);
          if (self.options.onConfirm) { self.options.onConfirm(); }
          self.windowView.close();
        }).fail(function () {
          Bootbox.alert(_.i18n('common.error', null, 'Something went wrong. Please try again.'));
        });
      }).fail(function () {
        Bootbox.alert(_.i18n('common.error', null, 'Something went wrong. Please try again.'));
      });
    },

    onCancel: function () {
      this.windowView.close();
    }
  });
});

